/* eslint-disable */
"use strict";

var config, service, esterni;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  esterni = config.VUE_APP_MOL_S_ESTERNI
}

exports.cerca = async function(filtri, options) {
  /*   if (filtri.marchi.length > 0) {
    return exports.cercaListino(filtri.marchi, filtri.testo, options, true)
  } else {
    return exports.cercaGenerico(filtri.testo, options, true)
  } */

  return exports.cercaListino(filtri.marchi, filtri.testo, options);
};

/* exports.cercaGenerico = async function(testo, options, usaFiltro) {
  const data = {
    testo,
    options,
    usaFiltro
  }
  const response = await fetch(`${service}/${esterni}/search`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return await response.json()
} */

exports.cercaListino = async function(marchi, testo, options) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    marchi,
    testo,
    options,
  };
  const response = await fetch(`${service}/${esterni}/search`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};

exports.elencoListini = async function() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${esterni}`);
  return await response.json();
};

exports.importaMetel = async function(filename, marchio, anno) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filename,
    marchio,
    anno,
  };
  const response = await fetch(`${service}/${esterni}/importa/metel`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};

// ********************************************************************************************************
// ********************************   GESTIONE FILE   *****************************************************
// ********************************************************************************************************
// ********************************************************************************************************

exports.uploadListinoForm = async function(form_data) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${esterni}/upload/repository`, {
      method: "POST",
      body: form_data,
    });
    return await response.text();
  } catch (err) {
    return err;
  }
};

exports.uploadListinoMultipleFile = async function(form_data) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${esterni}/repository/upload/multiple`,
      {
        method: "POST",
        body: form_data,
      }
    );
    return await response.text();
  } catch (err) {
    return err;
  }
};

exports.getFileList = async function(dir) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${esterni}/repository${dir ? "?dir=" + dir : ""}`
  );
  return await response.json();
};

exports.deleteFile = async function(file, dir) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    dir: dir,
    file,
  };
  const response = await fetch(`${service}/${esterni}/repository/delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
};
